import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import onahReducer, { OnahPersistConfig } from "../../persistor";
import { fetchBanks } from "services/common";
import { Bank } from "interface/bank";



type CommonState = {
    countries: Array<any>;
    banks: Array<Bank>;
    loadingBanks: boolean;
    loadingCountries: boolean;
}

const initialState: CommonState = {
    countries: [],
    banks: [],
    loadingCountries: false,
    loadingBanks: false,
}

export const getCountries = createAsyncThunk('common/getCountries', async (_, thunkApi) => {
    const state = (thunkApi.getState() as any).common as CommonState;
    if(state.loadingCountries) {
        return state.countries;
    }
    // const response = await getFakeCountries();
    return [];
});

export const getBanks = createAsyncThunk('common/getBanks', async (_, thunkApi) => {
    const state = (thunkApi.getState() as any).common as CommonState;
    if(state.banks.length) {
        return state.banks;
    } else {
        const response = await fetchBanks();
        if(response?.data) {
            return response?.data;
        }
    }
    return [];
});

export const commonSlice = createSlice({
    name: "co",
    initialState: initialState,
    reducers:{},
    extraReducers:(builders)=> {
        builders.addCase(getCountries.fulfilled, (state, action) => {
            if(action.payload) {
                state.countries = action.payload;
            }
        });
        builders.addCase(getBanks.pending, (state, action) => {
            state.loadingBanks = true;
        });
        builders.addCase(getBanks.fulfilled, (state, action) => {
            if(action.payload) {
                state.banks = action.payload;
            }
        });
        builders.addCase(getBanks.rejected, (state, action) => {
            state.loadingBanks = false;
        });
    }
})
// export const {} = commonSlice.actions;

const authPersistConfig: OnahPersistConfig = {
    key: commonSlice.name,
    blacklist: ['error', 'loading', 'loadingCountries', 'loadingBanks']
}

export const commonReducer = onahReducer(authPersistConfig,  commonSlice.reducer);

export const commonReducerPath = commonSlice.name;